module.exports={account_link_complete_message:"NEXONアカウント連携が完了しました。"};